import { getPreference } from '@openclassrooms/utils/config';

export const GOOGLE_COLOR = '#757575';

export function getGoogleConfig() {
  return {
    color: GOOGLE_COLOR,
    clientId: getPreference('google')?.appId,
  };
}
